import React from 'react';
import {motion} from 'framer-motion';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

import bg1 from '../img/img-salon/IMG-20250204-WA0000.jpg'

const Reception = () => {
    return (
        <StyledReception id="home">
            <div className="hero-txt">
                <h1>Nicolas d.</h1>
                <p>Coiffeur mixte</p>
                <p>Boulevard Saint-Marcel</p>
                <ul>
                    <li><Link to="reservation">Réservation</Link></li>
                    <li><Link to="/#tarifs">Nos prestations</Link></li>
                </ul>
            </div>
            <div className="background">
                <div className="blur-filter"></div>
                <img src={bg1} alt="salon-facade" />
            </div>
        </StyledReception>
    )
}

const StyledReception = styled(motion.div)`
    min-height: 85vh;
    overflow: hidden;
    .hero-txt{
        position: absolute;
        top: 50%;
        left: 50%;
        transform : translate(-50%, -50%);
        color: white;
        z-index: 5;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
    }
    a{
        color: white;
        text-decoration: none;
    }
    h1{
        font-weight: 400;
        font-family: "BrushScriptMTItalic", cursive;
        padding-bottom: 1rem;
        color: rgb(224, 224, 224)
    }
    p{
        line-height: 2rem;
    }
    ul{
        list-style: none;
        display: none;
        flex-direction: column;
        align-items: center;
        padding: 2rem 0rem;
    }
    li{
        background: #6190e8;
        padding: 1rem 2rem;
        margin: .5rem 0rem;
        cursor: pointer;
        font-weight: 600;
        width: 12rem;
        border-radius: 5px;
    }
    .background{
        width: 100%;
        height: 93vh;
        position: absolute;
        top: 0;
        left: 0;
    }
    .blur-filter{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.5);
        backdrop-filter: blur(3px);
        pointer-events: none;
        z-index: 2;
    }

    img{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 1;
    }

    @media (max-width: 768px){
        height: 100vh;
        .hero-txt{
            width: 100%;
        }
        ul{
            list-style: none;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 2rem 0rem;
        }
        .background{
            height: 100vh;
        }
    }
    `

export default Reception;